export default "__VITE_ASSET__Bi2fZUZu__"